var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckAccent500Md(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9457 0.621934L4.59234 8.6836L2.37568 6.31527C1.96734 5.93027 1.32568 5.90693 0.85901 6.2336C0.40401 6.57193 0.275676 7.16693 0.555676 7.64527L3.18068 11.9153C3.43734 12.3119 3.88068 12.5569 4.38234 12.5569C4.86068 12.5569 5.31568 12.3119 5.57234 11.9153C5.99234 11.3669 14.0073 1.81193 14.0073 1.81193C15.0573 0.7386 13.7857 -0.206399 12.9457 0.610268V0.621934Z",
    fill: "#87A8F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAccent500Md);
export default __webpack_public_path__ + "static/media/check-accent500-md.8d1d25d33e2ea52590a16a7462905e5d.svg";
export { ForwardRef as ReactComponent };